import React, { useRef, useEffect } from "react";
import { BounceLoader, MoonLoader } from "react-spinners";
import PaginationButton from "./PaginationButton";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";

const HeaderBar = ({
  backPage = null,
  backPageAction = null,
  nextPage = null,
  nextPageAction = null,
  nextPageEnabled = true,
  nextPageLoading = false,
  className = '',
  children
}) => {
  const { actions, state } = useStateMachineWrapper();
  const headerRef = useRef(null);
  // This ref will hold the last known intersection value.
  const lastIntersectingRef = useRef(state.session.headerVisible);

  useEffect(() => {
    const observerCallback = ([entry]) => {
      /*console.log("IntersectionObserver callback:", {
        isIntersecting: entry.isIntersecting,
        intersectionRatio: entry.intersectionRatio,
        boundingClientRect: entry.boundingClientRect
      });*/

      // Only update if the value has changed.
      if (headerRef.current && lastIntersectingRef.current !== entry.isIntersecting) {
        lastIntersectingRef.current = entry.isIntersecting;
        actions.update({ headerVisible: entry.isIntersecting });
      }
    };

    const observer = new IntersectionObserver(observerCallback, { threshold: 0.1 });

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, [actions]);

  return (
    <div ref={headerRef} className={`flex ${className}`}>
      {/* back button */}
      <div className="flex-none w-14 btn-bf-wrap">
        {backPage !== null && (
          <PaginationButton
            mode={'back'}
            page={backPage}
            action={backPageAction}
            enabled={!nextPageLoading}
          />
        )}
      </div>

      <div className="flex-1 mx-1">
        {children}
      </div>

      {/* next button */}
      <div className="flex-none w-14 btn-bf-wrap">
        {nextPageLoading !== false && (
          <div>
            <BounceLoader
              className="mx-auto mt-1"
              size={'3rem'}
              color={'#FFC72D'}
              speedMultiplier={0.75}
            />
          </div>
        )}
        {nextPageLoading === false && nextPage !== null && (
          <PaginationButton
            mode={'next'}
            page={nextPage}
            action={nextPageAction}
            enabled={nextPageEnabled}
          />
        )}
      </div>
    </div>
  );
};

export default HeaderBar;
